!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, i = {}, a = t.parcelRequire5f74;
  null == a && ((a = function(t) {
    if (t in e) return e[t].exports;
    if (t in i) {
      var a = i[t];
      delete i[t];
      var r = {
        id: t,
        exports: {}
      };
      return e[t] = r, a.call(r.exports, r, r.exports), r.exports;
    }
    var s = new Error("Cannot find module '" + t + "'");
    throw s.code = "MODULE_NOT_FOUND", s;
  }).register = function(t, e) {
    i[t] = e;
  }, t.parcelRequire5f74 = a), (0, a.register)("kmbQD", function(t, e) {
    var i, a, r, s;
    i = t.exports, a = "default", r = function() {
      return o;
    }, Object.defineProperty(i, a, {
      get: r,
      set: s,
      enumerable: !0,
      configurable: !0
    });
    class o {
      static doChange({id: t, quantity: e, properties: i = {}}, a = !1) {
        return fetch(`${Shopify.routes.root || "/"}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            id: t,
            quantity: e,
            properties: {
              ...i
            }
          })
        }).then(t => {
          if (!t.ok) throw new Error("Cart change failed");
          return t.ok && a && this.update(!0), t;
        }).catch(t => t);
      }
      static doUpdate(t, e, i = !1) {
        const a = Array.isArray(t) ? t.reduce((t, i) => ({
          ...t,
          [i]: e
        }), {}) : {
          id: e
        };
        return fetch(`${Shopify.routes.root || "/"}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            updates: a
          })
        }).then(t => {
          if (!t.ok) throw new Error("Cart update failed");
          return t.ok && i && this.update(!0), t;
        }).catch(t => t);
      }
      static doAdd({id: t, quantity: e, properties: i = {}}, a = !1, r = !0) {
        return fetch(`${Shopify.routes.root || "/"}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            items: [ {
              id: t,
              quantity: e,
              properties: {
                ...i
              }
            } ]
          })
        }).then(e => {
          if (!e.ok) throw new Error("Cart add failed");
          return e.ok && r ? (window.dispatchEvent(new CustomEvent("product:added", {
            detail: {
              variantId: t
            }
          })), e) : e.ok && a ? (this.update(!0), e) : void 0;
        }).catch(t => t);
      }
      static getCart() {
        return fetch(`${Shopify.routes.root || "/"}cart.js`, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        }).then(t => {
          if (!t.ok) throw new Error("Failed to fetch cart");
          return t;
        }).catch(t => t);
      }
      static cleanupTeleportedContent() {
        document.querySelectorAll("[data-teleport-origin]").forEach(t => {
          t.remove();
        });
      }
      static update(t = !1, e = "cart-drawer", i = null) {
        try {
          e = e.replace("cart-drawer", document.querySelector("cart-drawer").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        try {
          e = e.replace("cart-notification", document.querySelector("cart-notification").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        (e = e.split(",")).push("header"), e = [ ...new Set(e) ];
        const a = document.getElementById("Cart"), r = !!t || a && a.checked;
        return fetch(`${location.pathname}?sections=${e.join(",")}`, {
          method: "GET"
        }).then(t => t.json()).then(t => {
          this.cleanupTeleportedContent(), Object.entries(t).forEach(t => {
            const [e, a] = t, s = (new DOMParser).parseFromString(a, "text/html");
            if (e.includes("cart-notification")) {
              const t = document.querySelector("cart-notification"), e = s.querySelector("cart-notification");
              t && e && (t.innerHTML = e.innerHTML);
            }
            i ??= [ `[id^="shopify-section-"][id$="${e}"]` ], i.push("header [data-cart-count-desktop]", "header [data-cart-count-mobile]", "form [data-cart-count]", "[data-cart-link]"), 
            i.forEach(t => {
              document.querySelectorAll(t).forEach(e => {
                const i = s.querySelector(t);
                i && (e.innerHTML = r ? i.innerHTML.replace('id="Cart"', 'id="Cart" checked') : i.innerHTML);
              });
            });
          });
        });
      }
    }
  });
  var r = a("kmbQD");
  class s extends HTMLElement {
    constructor() {
      super(), this.initializeElements(), this.initializeData(), this.setupSwymIntegration();
    }
    initializeElements() {
      if (this.form = this.querySelector("[data-form]"), this.formWrapper = document.querySelector("[data-product-form-wrapper]"), 
      !this.form) return;
      const t = this.form.getAttribute("id");
      this.formSelector = t ? `#${t}` : null, t || console.error("Product form missing ID attribute - Swym integration may not work properly");
      const e = `[data-product-price="${this.dataset.productId}"]`;
      Object.assign(this, {
        submit: this.form.querySelector("[data-submit]"),
        submitText: this.form.querySelector("[data-submit-text]"),
        idInput: this.form.querySelector("[data-id]"),
        swymButton: this.form.querySelector(".swym-add-to-wishlist[data-variant-id]"),
        radios: this.form.querySelectorAll("[data-option-radio]"),
        priceElements: [ ...new Set([ ...this.querySelectorAll("[data-price]"), ...document.querySelectorAll(`${e} [data-price]`) ]) ],
        compareAtPriceElements: [ ...new Set([ ...this.querySelectorAll("[data-compare-at-price]"), ...document.querySelectorAll(`${e} [data-compare-at-price]`) ]) ],
        foreignSubmits: document.querySelectorAll(`[form="${t}"]`),
        optionLabels: this.querySelectorAll("[data-option-label]"),
        sizeGuideTrigger: this.querySelector("[data-size-guide-trigger]"),
        viewSimilarTriggers: this.querySelectorAll("[data-view-similar]"),
        similarModal: this.querySelector("similar-products-modal"),
        frameSelect: this.form.querySelector("[data-frame-select]"),
        frameLabel: this.form.querySelector("[data-frame-label]")
      });
    }
    initializeData() {
      const t = this.querySelector("[data-product-variants]");
      this.variants = t ? JSON.parse(t.textContent) : [];
      const e = this.querySelector("[data-product-settings]");
      this.settings = e ? JSON.parse(e.textContent) : {
        lowStockLimit: 10
      };
      const i = this.querySelector("[data-pickup-variant-ids]");
      this.pickupVariantIds = new Set(i ? JSON.parse(i.textContent) : []), this.swat = null, 
      this.pendingSwymUpdate = null, this.currentVariant = null;
    }
    connectedCallback() {
      this.form && (this.form.addEventListener("submit", this.handleSubmit.bind(this)), 
      this.radios.forEach(t => t.addEventListener("change", t => this.handleVariantChange(t))), 
      this.foreignSubmits.forEach(t => t.addEventListener("click", this.handleForeignSubmit.bind(this))), 
      this.sizeGuideTrigger && this.sizeGuideTrigger.addEventListener("click", this.openSizeGuide.bind(this)), 
      this.viewSimilarTriggers.forEach(t => t.addEventListener("click", this.openSimilarProducts.bind(this))), 
      this.similarModal && (this.similarModal.addEventListener("similar-products-modal:updated", () => this.updateViewSimilar(this.currentVariant)), 
      this.similarModal.addEventListener("similar-products-modal:toggled", t => this.viewSimilarTriggers.forEach(e => e.setAttribute("aria-expanded", String(t.detail.isOpen))))), 
      this.frameSelect && this.frameSelect.addEventListener("change", () => this.handleVariantChange()), 
      document.addEventListener("out-of-stock-modal:variant-changed", this.handleModalVariantChange.bind(this)), 
      this.initializeVariantState());
    }
    initializeVariantState() {
      const t = () => {
        this._isInitialLoad = !0, this.handleVariantChange(), this._isInitialLoad = !1;
      };
      if ("undefined" == typeof IntersectionObserver) return void t();
      const e = new IntersectionObserver(i => {
        i.some(t => t.isIntersecting) && (e.disconnect(), t());
      }, {
        rootMargin: "200px"
      });
      e.observe(this);
    }
    setupSwymIntegration() {
      if (!this.isWishlistEnabled()) return;
      const t = (e = 0) => {
        window.Swym?.registerComponent ? window.Swym.registerComponent(t => {
          this.swat = t, this.pendingSwymUpdate?.(), this.pendingSwymUpdate = null;
        }) : e < 300 ? setTimeout(() => t(e + 1), 100) : console.warn("Swym utility did not become available within 30 seconds");
      };
      t();
    }
    openSizeGuide(t) {
      t.preventDefault();
      const e = document.querySelector("product-details");
      if (!e) return;
      const i = e.querySelector('[data-tab-trigger="size_guide"]');
      i && i.dispatchEvent(new MouseEvent("click", {
        bubbles: !0,
        cancelable: !0,
        view: window
      }));
    }
    openSimilarProducts(t) {
      t.preventDefault(), this.similarModal && ("function" != typeof this.similarModal.open ? this.similarModal.querySelector("details")?.setAttribute("open", "") : this.similarModal.open(t.currentTarget));
    }
    updateViewSimilar(t) {
      if (!this.viewSimilarTriggers.length) return;
      this._isInitialLoad || "function" != typeof this.similarModal?.updateSize || this.similarModal.updateSize(this.getVariantSize(t));
      const e = Boolean(this.similarModal?.querySelector("[data-slide]")), i = Boolean(t) && !t.available && e;
      this.viewSimilarTriggers.forEach(t => t.classList.toggle("is-active", i));
    }
    getVariantSize(t) {
      if (!t?.options) return null;
      const e = Array.from(this.optionLabels).findIndex(t => "Size" === t.dataset.optionName);
      return -1 === e ? null : t.options[e] || null;
    }
    isWishlistEnabled() {
      return !0 === Shopify.MBF.wishlistEnabled;
    }
    getSelectedOptions(t = null) {
      const e = [];
      return [ ...new Set(Array.from(this.radios).map(t => t.name)) ].forEach(i => {
        if (t && t.name === i) e.push(t.value); else {
          const t = this.querySelector(`input[name="${i}"]:checked`);
          e.push(t ? t.value : null);
        }
      }), e;
    }
    handleVariantChange(t = null) {
      const e = t ? t.target : null;
      this.syncPrintOptions(e);
      const i = this.getSelectedOptions(e), a = this.findMatchingVariant(i);
      if (a) this.applyVariantUpdates(a); else if (1 === this.variants.length && 0 === this.radios.length) {
        const t = this.variants[0];
        this.applyVariantUpdates(t);
      } else {
        this.idInput.value = "", this.currentVariant = null, this.updateSubmitButtons(null), 
        this.updatePickupAvailability(null);
        const t = this.variants.find(t => t.available) || this.variants[0];
        this.updateSwymButton(t);
      }
      this.updateOptionLabels(i), this.updateOptionAvailability(i), this.updatePrintAvailability(), 
      this.updateStockDisplay(i), this.updateViewSimilar(this.currentVariant), t && document.dispatchEvent(new CustomEvent("product-form:variant-changed", {
        detail: {
          selectedOptions: i,
          matchingVariant: a,
          productId: this.dataset.productId
        }
      }));
    }
    applyVariantUpdates(t) {
      this.idInput.value = t.id, this.currentVariant = t, this.updateSubmitButtons(t), 
      this.updatePrice(t), this.updateSwymButton(t), this.updateURL(t), this.updatePickupAvailability(t);
    }
    handleModalVariantChange(t) {
      if (t.detail.productId !== this.dataset.productId) return;
      const {selectedOptions: e} = t.detail;
      if (this.frameSelect && e[0]) {
        const {size: t, frame: i} = this.parsePrintValue(e[0]), a = this.form.querySelector(`[data-option-radio][data-size="${t}"]`);
        return a && (a.checked = !0), Array.from(this.frameSelect.options).some(t => t.value === i) && (this.frameSelect.value = i), 
        void this.handleVariantChange();
      }
      e.forEach((t, e) => {
        if (t) {
          const i = this.querySelector(`input[name="option${e + 1}"][value="${t}"]`);
          i && !i.checked && (i.checked = !0);
        }
      }), this.handleVariantChange();
    }
    findMatchingVariant(t) {
      return this.variants.find(e => e.options.every((e, i) => e === t[i]));
    }
    updateSubmitButtons(t) {
      const e = t?.available, i = Shopify.MBF.settings?.stock_notify;
      let a, r;
      t ? e ? (a = !1, r = window.strings.addToCart) : i ? (a = !1, r = window.strings?.outOfStock?.notify || "Notify me") : (a = !0, 
      r = window.strings.soldOut) : (a = !0, r = window.strings.selectOptions), a ? this.submit.setAttribute("data-disabled", "true") : this.submit.removeAttribute("data-disabled"), 
      this.submitText.textContent = r, this.foreignSubmits.forEach(t => {
        a ? t.setAttribute("data-disabled", "true") : t.removeAttribute("data-disabled");
        const e = t.querySelector("[data-submit-text]");
        e && (e.textContent = r);
      });
    }
    formatPrice(t) {
      return Shopify.formatMoney(t, Shopify.money_format).replace(/([.,])00(\D*)$/, "$2");
    }
    updatePrice(t) {
      this.priceElements.length && (void 0 !== t.price && this.priceElements.forEach(e => {
        e.textContent = this.formatPrice(t.price);
      }), this.compareAtPriceElements.forEach(e => {
        t.compare_at_price && t.compare_at_price > t.price ? (e.textContent = this.formatPrice(t.compare_at_price), 
        e.classList.remove("hidden")) : (e.textContent = "", e.classList.add("hidden"));
      }));
    }
    updateSwymButton(t) {
      if (!this.isWishlistEnabled() || !t?.id) return;
      const e = this.form.getAttribute("id");
      this.swymButton && this.swymButton.setAttribute("data-variant-id", t.id), e && document.querySelectorAll(`.swym-add-to-wishlist[data-form="${e}"]`).forEach(e => e.setAttribute("data-variant-id", t.id)), 
      this.executeWhenSwatReady(() => this.reinitializeSwymButtons(e));
    }
    executeWhenSwatReady(t) {
      this.isWishlistEnabled() && (this.swat?.initializeActionButtons ? t() : this.pendingSwymUpdate = t);
    }
    reinitializeSwymButtons(t) {
      this.formSelector ? (this.swat.initializeActionButtons(this.formSelector, ".swym-add-to-wishlist[data-variant-id]"), 
      t && this.swat.initializeActionButtons("body", `.swym-add-to-wishlist[data-form="${t}"]`)) : console.error("Cannot initialize Swym buttons: form selector not available");
    }
    async updatePickupAvailability(t) {
      const e = document.querySelectorAll("[data-pickup-trigger]"), i = document.querySelectorAll("[data-pickup-tab-wrapper]"), a = document.querySelectorAll('details[data-tab-id="pickup_availability"]');
      if (this._isInitialLoad) return;
      const r = () => {
        e.forEach(t => t.classList.add("hidden")), i.forEach(t => t.setAttribute("hidden", "")), 
        a.forEach(t => {
          t.classList.add("hidden"), t.removeAttribute("open");
        });
      };
      if (!t) return void r();
      const s = this.dataset.sectionId;
      if (s) try {
        const o = `${window.location.pathname}?variant=${t.id}&section_id=${s}`, n = await fetch(o);
        if (!n.ok) throw new Error(`Fetch failed: ${n.status}`);
        const l = await n.text(), d = (new DOMParser).parseFromString(l, "text/html"), c = d.querySelector("[data-pickup-trigger]");
        if (!(c && !c.classList.contains("hidden"))) return void r();
        const u = c.querySelector("[data-pickup-stores-text]");
        u && e.forEach(t => {
          const e = t.querySelector("[data-pickup-stores-text]");
          e && (e.innerHTML = u.innerHTML);
        });
        const h = d.querySelector("[data-pickup-stores-list]");
        h && document.querySelectorAll("[data-pickup-stores-list]").forEach(t => {
          t.innerHTML = h.innerHTML;
        }), e.forEach(t => t.classList.remove("hidden")), i.forEach(t => t.removeAttribute("hidden")), 
        a.forEach(t => t.classList.remove("hidden")), this.updatePickupOptionLabels(t);
      } catch (t) {
        console.error("Failed to update pickup availability:", t);
      } else this.updatePickupOptionLabels(t);
    }
    updatePickupOptionLabels(t) {
      t.options && t.options.forEach((t, e) => {
        document.querySelectorAll(`[data-pickup-option="${e + 1}"] [data-pickup-option-value]`).forEach(e => {
          e.textContent = t;
        });
      });
    }
    handleStockNotification(t) {
      const e = document.querySelector("out-of-stock-form");
      if (e) {
        e.setAttribute("data-variant-id", t.id), e.setAttribute("data-product-id", this.dataset.productId);
        const i = this.getSelectedOptions();
        document.dispatchEvent(new CustomEvent("product-form:sync-to-modal", {
          detail: {
            selectedOptions: i,
            variant: t,
            productId: this.dataset.productId
          }
        }));
        const a = e.closest("teleport-details");
        if (a) {
          const t = a.querySelector("details");
          if (t) {
            const e = t.querySelector("summary");
            if (e) e.click(); else {
              const e = t.closest("details-disclosure");
              e && e.close instanceof Function && e.open();
            }
          } else console.error("Details element not found in teleport-details");
        } else console.error("Teleport-details parent not found for out-of-stock modal");
      } else console.error("Out-of-stock modal not found");
    }
    handleForeignSubmit(t) {
      t.preventDefault();
      const e = this.getCurrentVariant();
      e ? this.canSubmitVariant(e) ? this.form.dispatchEvent(new Event("submit", {
        cancelable: !0
      })) : (console.error("Cannot add out of stock variant to cart"), this.formWrapper.scrollIntoView({
        behavior: "smooth"
      })) : this.formWrapper.scrollIntoView({
        behavior: "smooth"
      });
    }
    handleSubmit(t) {
      if (t.preventDefault(), this.submit?.hasAttribute("data-disabled")) return;
      const e = this.getCurrentVariant();
      if (e) return e.available ? void this.addToCart(e) : Shopify.MBF.settings?.stock_notify ? void this.handleStockNotification(e) : void this.setSubmitTemptState(window.strings.soldOut);
      this.formWrapper && this.formWrapper.scrollIntoView({
        behavior: "smooth"
      });
    }
    getCurrentVariant() {
      const t = this.idInput?.value;
      return t ? this.variants.find(e => e.id === parseInt(t)) : null;
    }
    canSubmitVariant(t) {
      return t.available || Shopify.MBF.settings?.stock_notify;
    }
    closeParentModals() {
      window.TeleportDetails?.closeFromTeleportedContent && window.TeleportDetails.closeFromTeleportedContent(this);
      const t = this.closest("[data-teleport-origin]");
      if (t) {
        const e = t.getAttribute("data-teleport-origin"), i = document.querySelector(`teleport-details[data-teleport-id="${e}"]`);
        if (i) {
          const t = i.closest("details-disclosure");
          t && "function" == typeof t.close && t.close();
        }
      } else {
        const t = this.closest("details-disclosure");
        t && "function" == typeof t.close && t.close();
      }
    }
    isWithinCartContext() {
      if (this.closest("cart-drawer")) return !0;
      const t = this.closest("[data-teleport-origin]");
      if (t) {
        const e = t.getAttribute("data-teleport-origin"), i = document.querySelector(`teleport-details[data-teleport-id="${e}"]`);
        if (i) return !!i.closest("cart-drawer");
      }
      return !1;
    }
    addToCart(t) {
      if (!t.available) return console.error("Attempted to add out of stock variant to cart:", t.id), 
      void this.setSubmitTemptState(window.strings.error);
      this.setSubmitLoadingState();
      const e = !this.isWithinCartContext();
      r.default.doAdd({
        id: t.id,
        quantity: 1,
        properties: {
          _esid: window.EasySizeParametersDebug?.easysize?.pageview_id?.toString() || "-1"
        }
      }, !0, e).then(t => {
        const e = 200 === t.status ? window.strings.added : window.strings.error;
        this.setSubmitTemptState(e), 200 === t.status && this.closeParentModals();
      }).catch(() => this.setSubmitTemptState(window.strings.error));
    }
    setSubmitLoadingState() {
      this.setButtonState(!0, window.strings.adding);
    }
    setSubmitTemptState(t) {
      this.setButtonState(!1, t), setTimeout(() => this.restorePreviousButtonText(), 1e3);
    }
    setButtonState(t, e) {
      t ? this.submit.setAttribute("data-disabled", "true") : this.submit.removeAttribute("data-disabled"), 
      this.foreignSubmits.forEach(i => {
        t ? i.setAttribute("data-disabled", "true") : i.removeAttribute("data-disabled");
        const a = i.querySelector("[data-submit-text]");
        a && (a.dataset.previousText || (a.dataset.previousText = a.innerHTML), a.innerHTML = e);
      }), this.submitText.dataset.previousText || (this.submitText.dataset.previousText = this.submitText.innerHTML), 
      this.submitText.innerHTML = e;
    }
    restorePreviousButtonText() {
      this.submitText.dataset.previousText && (this.submitText.innerHTML = this.submitText.dataset.previousText), 
      this.foreignSubmits.forEach(t => {
        const e = t.querySelector("[data-submit-text]");
        e && e.dataset.previousText && (e.innerHTML = e.dataset.previousText);
      });
    }
    updateOptionLabels(t) {
      [ ...new Set(Array.from(this.radios).map(t => t.name)) ].forEach((e, i) => {
        const a = parseInt(e.replace("option", "")) - 1, r = t[a], s = this.querySelector(`input[name="${e}"]`)?.closest(".flex.flex-col.gap-3"), o = s?.querySelector("[data-option-label]");
        if (o && r) {
          const t = o.dataset.optionName || o.textContent.split(":")[0];
          o.textContent = `${t}: ${r}`;
        }
      });
    }
    updateOptionAvailability(t) {
      this.radios.forEach(e => {
        const i = parseInt(e.name.replace("option", "")) - 1, a = e.value;
        let r = !1;
        r = this.variants.some(e => !!e.available && (e.options[i] === a && e.options.every((e, a) => a === i || (null === t[a] || t[a] === e)))), 
        e.toggleAttribute("aria-out-of-stock", !r);
      });
    }
    parsePrintValue(t) {
      const e = t.indexOf(" - ");
      return -1 === e ? {
        size: t,
        frame: ""
      } : {
        size: t.slice(0, e),
        frame: t.slice(e + 3)
      };
    }
    getPrintValuesForSize(t) {
      return this.variants.map(t => ({
        ...this.parsePrintValue(t.options[0]),
        variant: t
      })).filter(e => e.size === t).map(t => ({
        value: t.variant.options[0],
        frame: t.frame,
        available: t.variant.available
      }));
    }
    syncPrintOptions(t = null) {
      if (!this.frameSelect) return;
      const e = void 0 !== t?.dataset?.size ? t : this.form.querySelector("[data-option-radio]:checked");
      if (!e) return;
      const i = e.dataset.size, a = this.getPrintValuesForSize(i);
      let r = this.frameSelect.value;
      if (!a.some(t => t.frame === r)) {
        const t = a.find(t => t.available) || a[0];
        t && (r = t.frame);
      }
      this.frameSelect.value !== r && (this.frameSelect.value = r), this.frameLabel && (this.frameLabel.textContent = r), 
      this.radios.forEach(t => {
        const e = this.getPrintValuesForSize(t.dataset.size), i = e.find(t => t.frame === r) || e.find(t => t.available) || e[0];
        i && (t.value = i.value);
      });
    }
    updatePrintAvailability() {
      if (!this.frameSelect) return;
      this.radios.forEach(t => {
        const e = this.getPrintValuesForSize(t.dataset.size).some(t => t.available);
        t.toggleAttribute("aria-out-of-stock", !e);
      });
      const t = this.form.querySelector("[data-option-radio]:checked");
      if (!t) return;
      const e = this.getPrintValuesForSize(t.dataset.size);
      Array.from(this.frameSelect.options).forEach(t => {
        t.disabled = !e.some(e => e.frame === t.value);
      });
    }
    updateStockDisplay(t) {
      this.querySelectorAll("[data-low-stock]").forEach(t => t.remove()), this.frameSelect || this.radios.forEach(e => {
        const i = e.parentNode.querySelector("[data-value]"), a = parseInt(e.name.replace("option", "")) - 1, r = [ ...t ];
        r[a] = e.value;
        const s = this.calculateLowestStock(r);
        s.hasAvailable && s.lowest <= this.settings.lowStockLimit && i.insertAdjacentHTML("beforeend", `<div class="text-sm text-scheme-error text-right" data-low-stock>\n            ${window.strings.product.lowStock.replace("{{ value }}", s.lowest)}\n          </div>`);
      });
    }
    calculateLowestStock(t) {
      let e = 1 / 0, i = !1;
      return this.variants.forEach(a => {
        this.optionsMatch(a.options, t) && a.available && (i = !0, a.inventory_quantity < e && (e = a.inventory_quantity));
      }), {
        lowest: e === 1 / 0 ? 0 : e,
        hasAvailable: i
      };
    }
    optionsMatch(t, e) {
      return t.every((t, i) => null === e[i] || t === e[i]);
    }
    updateURL(t) {
      if (!this.hasAttribute("data-url") || this.variants.length <= 1 || !t || !this.querySelector('[type="submit"]')) return;
      const e = new URL(window.location.href);
      e.searchParams.set("variant", t.id);
      const i = `${this.dataset.url}${e.searchParams.toString() ? `?${e.searchParams}` : ""}`;
      window.history.replaceState({
        path: i
      }, "", i);
    }
  }
  customElements.get("product-form") || customElements.define("product-form", s);
}();